<script>
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    geojson: {
      type: Object,
      required: true,
    },
    showFromZoom: {
      type: Number,
      required: true,
    },
    geoJsonStyle: {
      type: Object,
      default: () => {},
    },
    selectedFeatureCode: {
      type: String,
      required: false,
    },
    selectedFeatureFillColor: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      geoJsonObj: null,
      dataLayer: null,
    };
  },

  methods: {
    updateSelectedFeature() {
      this.updateStyle();
    },
    updateStyle() {
      this.dataLayer.setStyle((feature) => {
        const styling = {
          ...this.geoJsonStyle,
          visible: this.map.zoom >= this.showFromZoom,
        };
        if (
          this.selectedFeatureFillColor && feature.getProperty('code') === this.selectedFeatureCode
        ) {
          styling.fillColor = this.selectedFeatureFillColor;
        }
        return styling;
      });
    },
  },

  watch: {
    selectedFeatureCode() {
      this.updateSelectedFeature();
    },
  },

  mounted() {
    this.dataLayer = new this.google.maps.Data({ map: this.map });
    this.geoJsonObj = this.dataLayer.addGeoJson(this.geojson);
    this.updateStyle();

    this.map.addListener('zoom_changed', () => {
      this.updateStyle();
    });

    this.dataLayer.addListener('click', (event) => {
      this.$emit('featureSelected', event.feature.getProperty('code'));
    });

    this.updateSelectedFeature();
  },
  render() {
    return null;
  },
};
</script>
